module.exports = __webpack_public_path__ + "img/liushui (5).7d6bc94b.png";